import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    console.log('login clicked');
    
    e.preventDefault();
    // const res = await fetch("http://localhost:5002/api/admin/login", {
    const res = await fetch("https://kingdomhomesapi.onrender.com/api/admin/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });

    const data = await res.json();
    if (data.success) {
      sessionStorage.setItem("adminToken", data.token);
      navigate("/admin");
    } else {
      alert("Invalid password");
    }
  };

  const handleForgotPassword = async () => {
    if (!email) return alert("Please enter your email.");
    setLoading(true);
    try {
      const res = await fetch("https://localhost:5002/api/admin/forgot-password", {
      // const res = await fetch("https://kingdomhomesapi.onrender.com/api/admin/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      alert(data.message);
      setShowModal(false);
      setEmail("");
    } catch (err) {
      alert("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Admin Login</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="password"
          placeholder="Enter Admin Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
        />
        <button type="submit" style={styles.button}>
          Login
        </button>
        <button
          type="button"
          onClick={() => setShowModal(true)}
          style={styles.linkButton}
        >
          Forgot Password?
        </button>
      </form>

      {/* ====== Modal Section ====== */}
      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={{ color: "#D81F27" }}>Forgot Password</h3>
            <input
              type="email"
              placeholder="Enter your admin email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
            />
            <div style={styles.modalActions}>
              <button
                onClick={handleForgotPassword}
                style={styles.button}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
              <button
                onClick={() => setShowModal(false)}
                style={styles.cancelButton}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    height: "80vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "#f3f4f6",
    fontFamily: "Segoe UI, sans-serif",
  },
  title: {
    fontSize: "1.8rem",
    color: "#D81F27",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  input: {
    padding: "10px 15px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "16px",
    width: "250px",
  },
  button: {
    padding: "10px 15px",
    border: "none",
    borderRadius: "6px",
    background: "#D81F27",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
  },
  linkButton: {
    background: "none",
    color: "#007BFF",
    border: "none",
    cursor: "pointer",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    background: "#fff",
    padding: "25px 30px",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "300px",
    textAlign: "center",
  },
  modalActions: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  },
  cancelButton: {
    padding: "10px 15px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    background: "#f3f4f6",
    color: "#333",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default AdminLogin;
